import { render, staticRenderFns } from "./ProgramPOABitacoraRecap.vue?vue&type=template&id=1588789a"
import script from "./ProgramPOABitacoraRecap.vue?vue&type=script&lang=js"
export * from "./ProgramPOABitacoraRecap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports